import { Box } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

import useAPI from "../../../../api/hooks/useAPI";
import { integrationKeys } from "../../../../api/queryKeys";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";
import { Toast } from "../../../../components/Toast";

const GCPConnectForm = () => {
  const { registerGcpIntegration } = useAPI();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);

  const handleConnectClick = async () => {
    setLoading(true);
    try {
      await registerGcpIntegration();
      queryClient.invalidateQueries({
        queryKey: integrationKeys.all,
      });
      Toast.success("Connection succeeded");
    } catch (error) {
      if (error.response) {
        Toast.error(`Something went wrong: ${error.response.data.detail}`);
      } else {
        Toast.error("An error occurred while processing the request.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" justifyContent="center">
      <PrimaryButton
        type="button"
        onClick={handleConnectClick}
        isLoading={loading}
        disabled={loading}
        size="medium"
      >
        Check Connection
      </PrimaryButton>
    </Box>
  );
};

export default GCPConnectForm;
